import { fulfilled, pending, rejected } from '../../../utils';
import { CERTIFICATE } from '../../actions/actiontype';

const initialState = {
	status: '',
	loading: false,
	message: '',
	data: '',
	error: '',
};

const certificateReducer = (state = initialState, action) => {
	switch (action.type) {
		case pending(CERTIFICATE):
			return {
				...state,
				loading: true,
				message: '',
				status: '',
				data: '',
				error: '',
			};
		case fulfilled(CERTIFICATE):
			return {
				...state,
				loading: false,
				status: action.payload.data.status,
				message: action.payload.data.message,
				data: action.payload.data.data,
				error: '',
			};
		case rejected(CERTIFICATE):
			return {
				...state,
				loading: false,
				message: '',
				error: status ===500 ? "Something went wrong. Please try again later" : action?.payload?.response.data.message,
			};
		default:
			return state;
	}
};

export default certificateReducer;
